import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseService } from "../../services/base.service";

export interface AuthoriseUrlResponse {
  url: string;
}

export interface AccountLinkResponse {
  accountLinkId: string;
  cnhCompanyId: string;
  status: string;
  linkedAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class FieldOpsAuthService extends BaseService {

  private readonly baseUrl = this.API_ADMIN_BASE_URL + 'v1/field-ops';

  constructor(private httpClient: HttpClient) {
    super();
  }

  getAuthoriseUrl(): Observable<AuthoriseUrlResponse> {
    return this.httpClient.get<AuthoriseUrlResponse>(`${this.baseUrl}/auth/url`);
  }

  submitCallback(code: string, state: string, pgUserId: string, tenantId: string): Observable<AccountLinkResponse> {
    return this.httpClient.post<AccountLinkResponse>(`${this.baseUrl}/auth/callback`, {
      code,
      state,
      pgUserId: parseInt(pgUserId),
      tenantId: tenantId ? parseInt(tenantId) : null
    });
  }
}
